module.exports = __webpack_public_path__ + "img/bbz.44857511.png";